const getFilteredDashboardDetails = state =>
  state?.tpoDashboard?.filteredDashboardDetails
const getDashboardDetails = state => state?.tpoDashboard?.dashboardDetails
const selectors = { getFilteredDashboardDetails, getDashboardDetails }

export default selectors
